import { oneWay } from '@ember/object/computed';
import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import CampaignModel from 'cio/models/campaign';
import { all } from 'rsvp';
import CustomFormsService from 'cio/services/custom-forms';
import DS from 'ember-data';
import SubscriptionCenterService from 'cio/services/subscription-center';

export default class CampaignRoute extends Route {
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;
  @service store!: DS.Store;
  @service subscriptionCenter!: SubscriptionCenterService;

  crumb() {
    let model = this.modelFor(this.routeName) as CampaignModel;
    let helpLabel;
    let helpUrl;

    if (model.type === 'transactional') {
      helpLabel = 'event triggered campaigns';
      helpUrl = 'https://customer.io/docs/journeys/campaign-triggers/#event-trigger';
    } else if (model.type === 'behavioral') {
      helpLabel = 'segment triggered campaigns';
      helpUrl = 'https://customer.io/docs/journeys/campaign-triggers/#condition-trigger';
    }

    return {
      name: oneWay('model.name'),
      path: this.routeName,
      model,
      helpLabel,
      helpUrl,
    };
  }

  model(params: { campaign_id: string }) {
    return this.store.findRecord('campaign', params.campaign_id);
  }

  async beforeModel(transition: Transition) {
    await this.subscriptionCenter.initializeTask.perform();

    return super.beforeModel(transition);
  }

  async afterModel(model: CampaignModel, transition: Transition) {
    await super.afterModel(model, transition);

    if (model.isFormTriggered) {
      return all([this.facebookLeadAds.initialize(), this.customForms.initialize()]);
    }

    return;
  }

  // Redirect to the broadcasts route if it's an API triggered broadcast.
  //
  // If possible, we also want to redirect to the subroute that the current
  // transition intends to go to, so instead of just hardcoding a route name,
  // we take the target and replace campaigns with broadcasts. This works
  // because the two routes share (largely) the same nested route structure.
  redirect(model: CampaignModel, transition: Transition) {
    if (model.isApiTriggered) {
      this.router.transitionTo(transition.to.name.replace('campaigns.campaign', 'broadcasts.broadcast'), model.id);
    }
  }
}
